import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HomesReducers } from './homes.reducer';
import { HomesEffects } from './homes.effect';
import { HomesFacade } from './homes.facade';
import { HomesService } from './homes.service';

@NgModule({
  imports: [
    StoreModule.forFeature('homes', HomesReducers),
    EffectsModule.forFeature([
      HomesEffects,
    ]),
  ],
  providers: [
    HomesService,
    HomesFacade
  ]
})
export class HomesModule {}
